<template>
      <v-dialog v-model="dialog" persistent max-width="800px">
         <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>
        <v-toolbar dark color="primary elevation-1">
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit client: {{ user.id }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click.native="save">Update</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.firstname" label="Firstname" required :rules="itemRules"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.lastname" label="Lastname" required :rules="itemRules"></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 ></v-flex>
               <v-flex xs12 sm2 >
                <v-checkbox class="mt-3"
                  color="primary"
                  label="problem"
                  v-model="problem"
                  @change="form.problem = problem"
                ></v-checkbox>
              </v-flex>
              <v-flex xs10>
                <g-input
                  :required="true"
                  id="address_edit"
                  ref="address"
                  @change="setAddress"
                  @placechanged="setPlace"
                  :label="'Address'"
                  :clearable="true"
                  :delete="true"
                  :rules="itemRules"
                  :error="adress_notValid"
                ></g-input>
                <span v-if="adress_notValid" class="input-group__details error--text">Address is uncomplete, select a completed address.</span>
              </v-flex>
              <v-flex xs2>
                <v-text-field v-model="form.postbox" label="Postbox"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.birthday" label="birthday" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.mobile" label="mobile" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.tel" label="tel" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.email" label="Email"></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md3>
                <v-text-field v-model="form.client_from" label="Client from"></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md3>
                <v-text-field v-model="form.ssn" label="Register nr"></v-text-field>
              </v-flex>

              <v-flex xs2>
                <v-text-field v-model="form.mcode" label="M-code"></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  label="Price"
                  v-model="form.basePrice"
                  prepend-icon="euro_symbol"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 >
              <v-checkbox class="mt-3"
                color="primary"
                label="Factuur client?"
                v-model="form.factuur"
              ></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  label="Info"
                  v-model="form.info"
                  prepend-icon="info"
                  auto-grow
                  outlined
                  rows="3"
                  row-height="25"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
              <v-checkbox class="mt-3" @change="toggleInvoice"
              color="primary"
                label="Other invoice address?"
                v-model="invoiceAddress"
              ></v-checkbox>
              </v-flex>

              <v-flex xs12 v-if="invoiceAddress">
                <v-layout wrap class="invoiceAddress">
                  <v-flex xs12>
                    <div class="invoice-label">Use this for invoices:</div>
                    <v-text-field v-model="form.invoiceName" label="Name"></v-text-field>
                  </v-flex>
                  <v-flex xs10>
                    <g-input
                      id="invoiceAddress"
                      ref="invoice"
                      @change="setInvoiceAddress"
                      @placechanged="setInvoicePlace"
                      :label="'Address'"
                      :clearable="true"
                      :delete="true"
                      :rules="itemRules"
                      :error="fadress_notValid"
                    ></g-input>
                    <span v-if="fadress_notValid" class="input-group__details error--text">Address is uncomplete, select a completed address.</span>
                  </v-flex>
                <v-flex xs2>
                  <v-text-field v-model="form.postbox2" label="Postbox"></v-text-field>
                </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12>
                <v-textarea
                  label="History"
                  v-model="form.comment"
                  prepend-icon="chat"
                  multi-line
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm4 md4></v-flex>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
      </v-card>
      </v-form>
    </v-dialog>
</template>

<script>
  import gInput from '@/components/googlemaps/gInput';
  import FormMixin from '@/mixins/formvalid';
  export default {
    components: {
      'g-input': gInput
    },
    mixins: [FormMixin],
    props: ['dialog', 'user', 'form'],
    data () {
      return {
        valid: false,
        adress_notValid: false,
        fadress_notValid: false,
        dateFormatted: null,
        items: [],
        invoiceAddress: false,
        problem: null
      }
    },
    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      save () {
        if (this.$refs.form.validate()) {
          if (this.form.address && this.form.zip && this.form.city) {
            this.$emit('update', this.form);
          } else {
            this.adress_notValid = true;
            console.log('check your address');
          }
        }
      },
      close () {
        this.$emit('close');
      },
      toggleInvoice (v) {
        if (!v) {
          this.form.invoiceName = null;
          this.form.invoiceAddress = null;
        }
        console.log('toggleInvoice', v);
      },
      setAddress (v) {
        this.form.fullAddress = v;
      },
      setInvoiceAddress (v) {
        this.form.invoiceAddress = v;
      },
      setPlace (v) {
        if (v.street_number && v.postal_code && v.route && v.locality) {
          this.form.address = v.route + ' ' + v.street_number;
          this.form.zip = v.postal_code;
          this.form.city = v.locality || '';
          this.form.latitude = v.latitude;
          this.form.longitude = v.longitude;
          this.adress_notValid = false;
        } else {
          this.adress_notValid = true;
          this.form.fullAddress = this.form.address = this.form.zip = this.form.city = null;
        }
        console.log(v);
      },
      setInvoicePlace (v) {
        if (v.street_number && v.postal_code && v.route && v.locality) {
          this.fadress_notValid = false;
        } else {
          this.fadress_notValid = true;
          this.form.invoiceAddress = null;
        }
        console.log(v);
      },
      prefill (d) {
        for (var key in d) {
          this.form[key] = d[key]; // copies each property to the form object
        }
        this.adress_notValid = false;
        this.fadress_notValid = false;
        this.problem = this.user.problem;

        // this.$refs.address.update(d.fullAddress);
        this.$nextTick(() => { this.$refs.address.update(d.fullAddress); });
        if (d.invoiceAddress) {
          this.invoiceAddress = true;
          this.$nextTick(() => { this.$refs.invoice.update(d.invoiceAddress); });
        }
        if (d.invoiceName) {
          this.invoiceAddress = true;
          this.form.invoiceName = d.invoiceName;
        }
      },
      init (v) {
        if (v) {
          console.log('Edit: do init:', this.user);
          this.prefill(this.user);
        }
      }
    },
    watch: {
      dialog (value) {
        this.init(value);
      }
    }
  }
</script>
<style lang="scss">
.invoiceAddress {
  border: solid 1px #eee;
  padding: 0 20px 20px;
  .invoice-label {
    padding-top: 10px;
    color: #ccc;
  }
}
</style>
